import { TroubleTicketingSelectOptions } from './selectOptions';

export type SingleTroubleTicketingSelectOption = {
	displayName?: string; // element name shown in dropdown
	category?: string; // category which has to be sent by API request
	subcategory?: string; // subcategory which has to be sent by API request
	type?: string; // type which has to be sent by API request
	assignmentGroup?: string; // assignment group which has to be sent by API request
	select?: TroubleTicketingSelectOptions;
};

const model = {
	displayName: 'displayName',
	category: 'category',
	select: 'select',
};

export default model;
